// components/CustomeModal.jsx
import React from "react";
import { Button, Modal } from "antd";

const CustomeModal = ({
  open,
  title,
  message,
  okText = "Ok",
  cancelText = "Cancel",
  onOk,
  onCancel,
  confirmLoading = false,
  width = 500,
}) => {
  return (
    <Modal
      title={null} // default header hatane ke liye
      open={open}
      footer={null} // antd default footer bhi hataya
      onCancel={onCancel}
      width={width}
      className="custome_mail_modal"
    >
      <h4>{title}</h4>
      <p>{message}</p>
      <div className="custome_mail_modal_button">
        <Button className="border-button" onClick={onCancel}>
          {cancelText}
        </Button>
        <Button
          className="Fill-button"
          onClick={onOk}
          loading={confirmLoading}
        >
          {okText}
        </Button>
      </div>
    </Modal>
  );
};

export default CustomeModal;
